






















































































import {
  allPackageDeviceTypes,
  allPatientManagementWizardDetailedPatientInformationKeys as allDetailedPatientInfoKeys,
  getSimpleAttrFromDetailedAttr,
  PatientManagementWizardDetailedPatientInformationKeys as DetailedPatientInformationKeys,
  SimplePatientInformationKeys,
  VibePackageDeviceTypes as DeviceTypes,
} from '@/constants/patients'

import { PATIENT_NOUN } from '@/constants/app-variables'
import { UserActionContexts } from '@/constants/urls'

import { getPatientName } from '@/utils/patients'

import PatientManagementWizardPatientInformationStage from '@/components/patients/dialogs/components/PatientManagementWizardPatientInformationStage.vue'
import PatientManagementWizardDeviceAssignmentStage from '@/components/patients/dialogs/components/PatientManagementWizardDeviceAssigmentStage.vue'
import PatientManagementWizardInformationSummaryStage from '@/components/patients/dialogs/components/PatientManagementWizardInformationSummaryStage.vue'
import PatientManagementWizardFinalConfirmationStage from '@/components/patients/dialogs/components/PatientManagementWizardFinalConfirmationStage.vue'
import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { DetailedPatientActionNames, DetailedPatientGetterNames } from '@/store/modules/detailed-patient/keys'
import { ActionNames } from '@/store/modules/exercise/keys'
import { updatePatientQuery } from '@/jsonapi/DetailedPatient'
import { FlatDetailedPatient } from '@/store/modules/detailed-patient/getters'
import Error from '@/pages/Error.vue'

const enum WizardStageIndexes {
  PatientInformation = 0,
  DeviceAssignment = 1,
  InformationSummary = 2,
  FinalConfirmation = 3,
}

export default {
  components: {
    PatientManagementWizardPatientInformationStage,
    PatientManagementWizardDeviceAssignmentStage,
    PatientManagementWizardInformationSummaryStage,
    PatientManagementWizardFinalConfirmationStage,
  },

  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    userActionContext: {
      type: String,
      required: true,
    },
    simplePatientForEdit: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      patientNoun: PATIENT_NOUN,
      currentStageIndex: WizardStageIndexes.PatientInformation,
      patientInformationStage: WizardStageIndexes.PatientInformation,
      deviceAssignmentStage: WizardStageIndexes.DeviceAssignment,
      informationSummaryStage: WizardStageIndexes.InformationSummary,
      finalConfirmationStage: WizardStageIndexes.FinalConfirmation,
      patientInformation: {
        [DetailedPatientInformationKeys.PatientId]: null,
        [DetailedPatientInformationKeys.FirstName]: null,
        [DetailedPatientInformationKeys.LastName]: null,
        [DetailedPatientInformationKeys.DateOfBirth]: '',
        [DetailedPatientInformationKeys.PhoneNumber]: null,
        [DetailedPatientInformationKeys.CareGiver]: null,
        [DetailedPatientInformationKeys.InhalerType]: null,
        [DetailedPatientInformationKeys.Program]: null,
        [DetailedPatientInformationKeys.AvailableCareGivers]: [],
        [DetailedPatientInformationKeys.VibePackage]: null,
        [DetailedPatientInformationKeys.AvailableVibes]: [],
      },
      packageVibe: null,
      packageDeviceIds: {
        [DeviceTypes.Vibe]: null,
        [DeviceTypes.Gateway]: null,
        [DeviceTypes.Tracker]: null,
        [DeviceTypes.Inhaler]: null,
        [DeviceTypes.PulseOximeter]: null,
        [DeviceTypes.Scale]: null,
        [DeviceTypes.Thermometer]: null,
        [DeviceTypes.Bpm]: null,
        [DeviceTypes.Glucometer]: null,
      },
      patientInformationIsValid: false,
      deviceAssignmentIsValid: true,
      isSavingPatientData: false,
      isDownloadingDetailedInfo: false,
      errorMessage: null,
    }
  },

  computed: {
    ...mapGetters(ModuleNames.detailedPatient, [DetailedPatientGetterNames.patients]),

    contextIsNew() {
      return this.userActionContext === UserActionContexts.New
    },
    contextIsEdit() {
      return this.userActionContext === UserActionContexts.Edit
    },
    canProgressToNextWizardStage() {
      if (this.isSavingPatientData) return false
      if (this.currentStageIndex === WizardStageIndexes.PatientInformation) {
        return this.patientInformationIsValid
      }
      return this.patientInformationIsValid && this.deviceAssignmentIsValid
    },
    isFinalConfirmationStage() {
      return this.currentStageIndex === WizardStageIndexes.FinalConfirmation
    },
    wizardHeaders() {
      return [
        {
          stageNumber: WizardStageIndexes.PatientInformation + 1,
          stageName: 'Patient Information',
          isCurrent: this.currentStageIndex === WizardStageIndexes.PatientInformation,
          isComplete: this.currentStageIndex > WizardStageIndexes.PatientInformation,
          lineAfter: true,
        },
        {
          stageNumber: WizardStageIndexes.DeviceAssignment + 1,
          stageName: 'Package ID',
          isCurrent: this.currentStageIndex === WizardStageIndexes.DeviceAssignment,
          isComplete: this.currentStageIndex > WizardStageIndexes.DeviceAssignment,
          lineAfter: true,
        },
        {
          stageNumber: WizardStageIndexes.InformationSummary + 1,
          stageName: this.contextIsNew ? 'Confirm' : 'Confirm Changes',
          isCurrent: this.currentStageIndex === WizardStageIndexes.InformationSummary,
          isComplete: this.currentStageIndex > WizardStageIndexes.InformationSummary,
        },
      ].map(header => ({
        ...header,
        avatarBackground: header.isComplete || header.isCurrent ? 'primary' : 'white',
        avatarColor: header.isComplete || header.isCurrent ? 'white' : 'primary',
      }))
    },
    wizardActions() {
      return [
        {
          text: this.currentStageIndex === WizardStageIndexes.PatientInformation ? 'Cancel' : 'Go Back',
          depressed: true,
          color: 'light-grey',
          action:
            this.currentStageIndex === WizardStageIndexes.PatientInformation
              ? this.closeDialog
              : this.goToPreviousWizardStage,
          hide: this.isFinalConfirmationStage,
          disabled: this.isSavingPatientData,
        },
        {
          text:
            this.currentStageIndex === WizardStageIndexes.InformationSummary
              ? this.contextIsNew
                ? 'Confirm'
                : 'Confirm Changes'
              : this.currentStageIndex === WizardStageIndexes.FinalConfirmation
              ? 'Done'
              : 'Next',
          color: 'primary',
          action:
            this.currentStageIndex === WizardStageIndexes.InformationSummary
              ? this.savePatientDetails
              : this.currentStageIndex === WizardStageIndexes.FinalConfirmation
              ? this.closeDialog
              : this.goToNextWizardStage,
          disabled: !this.canProgressToNextWizardStage,
        },
      ]
    },
    patientFullName() {
      return getPatientName({
        id: '',
        firstName: this.patientInformation[DetailedPatientInformationKeys.FirstName],
        lastName: this.patientInformation[DetailedPatientInformationKeys.LastName],
      })
    },
  },
  watch: {
    simplePatientForEdit() {
      if (this.contextIsEdit) {
        allDetailedPatientInfoKeys.forEach(key => {
          this.patientInformation[key] = getSimpleAttrFromDetailedAttr(this.simplePatientForEdit, key)
          // this.patientInformation[key] = this.patientForEdit[key]
        })
        this.downloadDetails()
      }
    },
  },
  async mounted(): Promise<void> {
    // debugger
    await this.downloadDetails()
    // await this[DetailedPatientActionNames.getDetailedPatientById]({ patientId: this.patientForEdit[PatientInformationKeys.PatientId] })
  },
  methods: {
    ...mapActions(ModuleNames.detailedPatient, [DetailedPatientActionNames.getDetailedPatientById]),
    async downloadDetails(): Promise<void> {
      let patientId = this.simplePatientForEdit && this.simplePatientForEdit[SimplePatientInformationKeys.PatientId]
      if (patientId) {
        console.log(`downloadDetails() patient id: ${patientId}`)
        console.log(this.simplePatientForEdit)

        this.isDownloadingDetailedInfo = true
        await this[DetailedPatientActionNames.getDetailedPatientById]({ patientId: patientId })
        let details = this.currentPatientDetails()
        console.log('Success! downloaded details:')
        console.log(details)
        console.log('patient info before update: ')
        console.log(this.patientInformation)
        allDetailedPatientInfoKeys.forEach(key => {
          let d = details[key]
          this.patientInformation[key] = details[key]
        })
        let vibePackage = this.patientInformation[DetailedPatientInformationKeys.VibePackage]
        let self = this
        allPackageDeviceTypes.forEach(function(key) {
          let matchingDevice =
            vibePackage && vibePackage.devices && vibePackage.devices.filter(device => device.type == key)
          if (matchingDevice && matchingDevice[0]) {
            self.packageDeviceIds[key] = matchingDevice[0].deviceId
          }
        })
        console.log('assigned package device ids: ')
        console.log(this.packageDeviceIds)

        if (vibePackage && vibePackage.vibeId) {
          console.log('assigning vibe with id: ' + vibePackage.vibeId)

          this.packageVibe = vibePackage.vibe
          this.packageDeviceIds[DeviceTypes.Vibe] = vibePackage.vibeId
          this.packageDeviceIds[DeviceTypes.Gateway] = vibePackage.vibe && vibePackage.vibe.gatewayId
        } else {
          console.log('vibeId not found in detailed patient query')
        }
        console.log('patient info before update: ')
        let info = this.patientInformation
        console.log(info)
      }
      this.isDownloadingDetailedInfo = false
    },
    closeDialog() {
      this.resetWizard()
      this.$emit('closeDialog')
    },
    goToPreviousWizardStage() {
      if (this.currentStageIndex <= WizardStageIndexes.PatientInformation) return
      this.currentStageIndex = this.currentStageIndex - 1
    },
    goToNextWizardStage() {
      if (this.currentStageIndex >= WizardStageIndexes.FinalConfirmation) return
      this.currentStageIndex = this.currentStageIndex + 1
    },
    shouldShowWizardStage(index) {
      if (this.showDialog) {
        return this.currentStageIndex === index ? true : false
      }
      return false
    },
    currentPatientDetails() {
      let patientId = this.simplePatientForEdit[SimplePatientInformationKeys.PatientId]
      return this[DetailedPatientGetterNames.patients].find(patient => patient && patient.id === patientId)
    },
    savePatientDetails() {
      this.isSavingPatientData = true

      let patientForUpload = { ...this.currentPatientDetails() }
      allDetailedPatientInfoKeys.forEach(key => {
        patientForUpload[key] = this.patientInformation[key]
      })
      patientForUpload.updatePackage = true
      if (!patientForUpload[DetailedPatientInformationKeys.VibePackage]) {
        patientForUpload[DetailedPatientInformationKeys.VibePackage] = {}
      }
      patientForUpload[DetailedPatientInformationKeys.VibePackage].vibeId = this.packageDeviceIds[DeviceTypes.Vibe]
      patientForUpload[DetailedPatientInformationKeys.VibePackage].devices = []
      allPackageDeviceTypes.forEach(key => {
        if (this.packageDeviceIds[key]) {
          patientForUpload[DetailedPatientInformationKeys.VibePackage].devices.push({
            type: key,
            deviceId: this.packageDeviceIds[key],
          })
        }
      })

      this.errorMessage = null
      updatePatientQuery(patientForUpload as FlatDetailedPatient)
        .then(() => {
          this.currentStageIndex = WizardStageIndexes.FinalConfirmation
        })
        .catch((error: any) => {
          this.errorMessage = 'Failed to update. Please check the details and try again'
          this.isSavingPatientData = false
          console.log('Patient Update error', error)
        })
        .finally(() => {
          this.isSavingPatientData = false
        })
    },
    updateDeviceAssignmentValidation(event) {
      this.deviceAssignmentIsValid = event
    },
    updateVibeId(vibeId) {
      this.packageDeviceIds[DeviceTypes.Vibe] = vibeId
      let avail = this.patientInformation[DetailedPatientInformationKeys.AvailableVibes]
      let matching = avail && avail.filter(v => v.vibeId == vibeId)
      this.packageVibe = (matching && matching[0]) || { vibeId: vibeId } // update this for select too for now
    },
    resetWizard() {
      ;[
        DetailedPatientInformationKeys.FirstName,
        DetailedPatientInformationKeys.LastName,
        DetailedPatientInformationKeys.DateOfBirth,
        DetailedPatientInformationKeys.PhoneNumber,
        DetailedPatientInformationKeys.CareGiver,
        DetailedPatientInformationKeys.Program,
        DetailedPatientInformationKeys.VibePackage,
      ].forEach(key => (this.patientInformation[key] = null))
      this.packageId = null
      this.errorMessage = null
      this.currentStageIndex = WizardStageIndexes.PatientInformation
    },
  },
}
